import Icon from '../components/Icon.vue'

Icon.register({
  'torii-gate': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M376.4 32c39.5 0 100.2-14.3 135.6-32v96c0 17.7-14.3 32-32 32h-32v64h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v240c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-240h-256v240c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-240h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-64h-32c-17.7 0-32-14.3-32-32v-96c35.3 17.7 96.1 32 135.6 32h240.9zM128 128v64h96v-64h-96zM384 192v-64h-96v64h96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/torii-gate.js
// module id = 1816
// module chunks = 0